// extracted by mini-css-extract-plugin
export default {"root":"_3Kn6zukD","content":"e43I_jKa","write":"_2Zw331Oh","pararaph":"_1diB90TT","branding":"_2wZ5SMeT"};